import _extends from "@babel/runtime/helpers/esm/extends";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { ModalForm, ProCard } from '@ant-design/pro-components';
import { Empty, message } from 'antd';
import React from 'react';
import { useGlobalSetting } from "./Context";
import { GlobalSystemSetting } from "./System";
export var GlobalSetting = function GlobalSetting(properties) {
  var defaultContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Empty, {
    description: "\u6682\u65E0\u53EF\u7528\u7684\u914D\u7F6E\u9879",
    style: {
      margin: '48px 0'
    }
  }));
  var _useGlobalSetting = useGlobalSetting(),
    _useGlobalSetting2 = _slicedToArray(_useGlobalSetting, 2),
    setGlobalSetting = _useGlobalSetting2[1];
  return /*#__PURE__*/React.createElement(ModalForm, _extends({
    layout: "horizontal",
    modalProps: {
      styles: {
        body: {
          padding: 0
        }
      },
      destroyOnClose: true,
      centered: true
    },
    initialValues: JSON.parse(localStorage.getItem("JiShuXin['GlobalSetting']") || '{}'),
    title: "\u8BBE\u7F6E",
    onFinish: ( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(formData) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 保存数据
              setGlobalSetting(formData);
              // 返回
              // > -
              message.success('保存成功');
              // > -
              return _context.abrupt("return", true);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()),
    grid: true,
    rowProps: {}
  }, properties), /*#__PURE__*/React.createElement(ProCard, {
    ghost: true,
    tabs: {
      cardProps: {
        bodyStyle: {
          minHeight: 256
        }
      },
      items: [{
        key: 'system',
        label: "\u7CFB\u7EDF\u8BBE\u7F6E",
        children: /*#__PURE__*/React.createElement(GlobalSystemSetting, null)
      }, {
        key: 'security',
        label: "\u5B89\u5168\u8BBE\u7F6E",
        children: defaultContent
      }, {
        label: "\u901A\u77E5\u8BBE\u7F6E",
        children: defaultContent,
        key: 'notification'
      }],
      tabPosition: 'left'
    }
  }));
};